import { yup } from "@swa-ui/object";

let schemas;

export function getPriorityBoardingMktgSchemas() {
  if (!schemas) {
    schemas = {
      priorityBoardingConfirmation: mktgPriorityBoardingConfirmationSchema(),
      priorityBoardingPurchase: mktgPriorityBoardingPurchaseSchema(),
    };
  }

  return schemas;
}

function mktgPriorityBoardingConfirmationSchema() {
  return yup.object().shape({
    air_bound1_airportcodes: yup.string().optional(),
    air_bound1_date: yup.string().optional(),
    air_bound1_faretype: yup.string().optional(),
    air_bound2_airportcodes: yup.string().optional(),
    air_bound2_date: yup.string().optional(),
    air_bound2_faretype: yup.string().optional(),
    air_triptype: yup.string().optional(),
    confirmation_number: yup.string().optional(),
  });
}

function mktgPriorityBoardingPurchaseSchema() {
  return yup.object().shape({
    air_bound1_airportcodes: yup.string().optional(),
    air_bound1_date: yup.string().optional(),
    air_bound1_faretype: yup.string().optional(),
    air_bound1_stops: yup.string().optional(),
    air_bound1_stoptype: yup.string().optional(),
    air_bound2_airportcodes: yup.string().optional(),
    air_bound2_date: yup.string().optional(),
    air_bound2_faretype: yup.string().optional(),
    air_bound2_stops: yup.string().optional(),
    air_bound2_stoptype: yup.string().optional(),
    air_triptype: yup.string().optional(),
    confirmation_number: yup.string().optional(),
    isdomestic: yup.string().optional(),
    isinternational: yup.string().optional(),
    pnrisgetaways: yup.string().optional(),
  });
}
